(function () {
  var ARROW_URL = 'https://cdn.shopify.com/s/files/1/0575/3624/9916/files/SVG_Arrow_45deg.svg?v=1778838357';

  function injectArrow(btn) {
    if (!btn || btn.dataset.ctaArrow) return;
    btn.dataset.ctaArrow = '1';
    var img = document.createElement('img');
    img.src = ARROW_URL;
    img.alt = '';
    img.style.cssText = 'width:18px;height:18px;flex-shrink:0;display:inline-block;vertical-align:middle;';
    btn.appendChild(img);
  }

  function applyArrows() {
    document.querySelectorAll(
      '.product-form__submit:not([data-cta-arrow]),' +
      'kaching-bundle button:not([data-cta-arrow]),' +
      'kaching-bundle a.btn:not([data-cta-arrow])'
    ).forEach(injectArrow);
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyArrows();
    setTimeout(applyArrows, 600);
    setTimeout(applyArrows, 1800);
    new MutationObserver(applyArrows).observe(document.body, { childList: true, subtree: true });
  });
})();
